module.exports = __webpack_public_path__ + "static/media/sweet_6_tablet.9d585dbe.png";